import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const WarningTriangle = createSvgIcon(
  () => (
    <path d="M40.5131 33.0724L23.8801 4.64793C22.5526 2.46143 19.351 2.46143 18.1015 4.64793L1.39043 33.0724C0.140997 35.2589 1.70278 37.992 4.27973 37.992H37.6238C40.2008 37.992 41.7626 35.2589 40.5131 33.0724ZM19.1167 13.6282C19.1167 12.613 19.8976 11.7541 20.9908 11.7541C22.006 11.7541 22.865 12.613 22.865 13.6282V23.6236C22.865 24.7169 22.006 25.4978 20.9908 25.4978C20.0538 25.4978 19.1167 24.7169 19.1167 23.6236V13.6282ZM20.9908 32.9943C19.5852 32.9943 18.492 31.9011 18.492 30.5736C18.492 29.246 19.5852 28.1528 20.9908 28.1528C22.3183 28.1528 23.4116 29.246 23.4116 30.5736C23.4116 31.9011 22.3183 32.9943 20.9908 32.9943Z" />
  ),
  '0 0 41 41'
);
